(() => {
  const STORAGE_KEY = 'atelier-color-mode';

  const getPreferredMode = () => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'light' || stored === 'dark') return stored;
    } catch (e) {
      /* ignore */
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  };

  const applyMode = (mode) => {
    document.documentElement.setAttribute('data-color-mode', mode);
    document.documentElement.style.colorScheme = mode;

    const metaTheme = document.querySelector('meta[name="theme-color"]');
    if (metaTheme) {
      metaTheme.setAttribute('content', mode === 'dark' ? '#121416' : '#f7f5f1');
    }

    document.querySelectorAll('[data-theme-mode-toggle]').forEach((button) => {
      const nextLabel = mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode';
      button.setAttribute('aria-label', nextLabel);
      button.setAttribute('aria-pressed', mode === 'dark' ? 'true' : 'false');
    });
  };

  const toggleMode = () => {
    const current = document.documentElement.getAttribute('data-color-mode') || getPreferredMode();
    const next = current === 'dark' ? 'light' : 'dark';
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {
      /* ignore */
    }
    applyMode(next);
  };

  const init = () => {
    applyMode(getPreferredMode());
    document.querySelectorAll('[data-theme-mode-toggle]').forEach((button) => {
      button.addEventListener('click', toggleMode);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
